import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlusSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPlusSmall"><Path d="M12 6.5V12M12 12V17.5M12 12H6.5M12 12H17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPlusSmall;
